import { render } from "./EditSortVideo.vue?vue&type=template&id=32d65a88"
import script from "./EditSortVideo.vue?vue&type=script&lang=js"
export * from "./EditSortVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__